<template>
	<v-container class="d-flex flex-column align-start" fluid fill-height pa-0>
		<FullHeader />
		<AdminConfigContainer />
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import AdminConfigContainer from './AdminConfigContainer'

export default {
	name: 'AdminConfigIndex',
	components: {FullHeader, AdminConfigContainer},
	data: () => ({
		loading: false
	}),
	mounted(){
	},
	methods: {
	}
};
</script>


<style>
	.scrollable-list{
		flex: 1 1 auto;
		height: 100%;
	}
	.scrollable-list #consultas-container{
		flex: 1 1 auto;
		height: 100%;
	}
</style>